var _rect, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvoyerMsg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "#003366"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3132_31568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6259 10.3563C10.5353 10.3434 10.4428 10.3534 10.357 10.3855C10.2712 10.4175 10.1948 10.4705 10.1347 10.5396C10.0746 10.6087 10.0327 10.6917 10.013 10.7812C9.99318 10.8706 9.99608 10.9635 10.0214 11.0515L11.0563 14.6559C11.122 14.885 11.2606 15.0865 11.451 15.2299C11.6414 15.3733 11.8733 15.4508 12.1116 15.4507H16.5869C16.7325 15.4507 16.8721 15.5086 16.9751 15.6115C17.078 15.7145 17.1358 15.8541 17.1358 15.9996C17.1358 16.1452 17.078 16.2848 16.9751 16.3878C16.8721 16.4907 16.7325 16.5485 16.5869 16.5485H12.1116C11.8733 16.5485 11.6414 16.626 11.451 16.7694C11.2606 16.9128 11.122 17.1143 11.0563 17.3433L10.0214 20.9485C9.99608 21.0365 9.99318 21.1294 10.013 21.2189C10.0327 21.3083 10.0746 21.3913 10.1347 21.4604C10.1948 21.5296 10.2712 21.5825 10.357 21.6145C10.4428 21.6466 10.5353 21.6566 10.6259 21.6438C14.7947 21.0517 18.6919 19.2286 21.8183 16.408C21.8755 16.3565 21.9212 16.2936 21.9525 16.2233C21.9838 16.153 22 16.077 22 16C22 15.9231 21.9838 15.847 21.9525 15.7767C21.9212 15.7064 21.8755 15.6435 21.8183 15.592C18.6919 12.7715 14.7947 10.9484 10.6259 10.3563Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#003366"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3132_31568"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvoyerMsg);
export default __webpack_public_path__ + "static/media/envoyerMsg.e58538472a250473489e22c95697bacf.svg";
export { ForwardRef as ReactComponent };